import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../../theme-constants/colors';
import { helveticaBold } from '../../../theme-constants/typograhy-overrides';


export const midyearSelectionStyles = makeStyles((theme) => ({
    midYearSelectionContainer: {
        
        '& .midyear-selection': {
            '&-header': {
                marginBottom: theme.spacing(1),
            },
            [theme.breakpoints.up('lg')]: {
                display: 'grid',
                gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
                columnGap: theme.spacing(1),
            },
            '&-plan': {
                '&-item': {
                    '&-edited': {
                       
                        '& .MuiInputBase-root': {
                            borderColor: tcsmColors.green,
                            '& > *': {
                                fontFamily: helveticaBold,
                                color: tcsmColors.green,
                            },
                        },
                    },
                    '& .form-item': { // removes inline-block when autoWidth items are in plan table 
                        '& > div':{
                        [theme.breakpoints.up('lg')]: {
                            display: 'block',
                            },
                        },
                        '& .MuiInputBase-root': {
                            [theme.breakpoints.up('lg')]: {
                                width: '100%',
                            },
                        },
                        '& .MuiFormLabel-root > div': {
                            [theme.breakpoints.up('lg')]: {
                                marginLeft: '0',
                            },
                            
                        },
                        
                    },
                    
                    [theme.breakpoints.down('md')]: {
                        marginTop: theme.spacing(1),
                    },
                    '&-header': {
                        display: 'flex',
                    },
                    '&-label': {
                        marginRight: theme.spacing(.5),
                    },
                    '&-text': {
                        '&-original': {
                            color: tcsmColors.darkBlue,
                        },
                        '&-new': {
                            color: tcsmColors.green,                            
                        },
                    },
                    '&-sublabel': {
                        marginTop: theme.spacing(.5),
                        '&-heading': {
                            marginBottom: theme.spacing(.25),
                        },
                    },

                    '&-dropdown': {
                        '&-option': {
                            display: 'flex',
                            overflow:'hidden',
                        },
                    },
                    
                },
            },
        },
        '&-additional-message': {
            paddingBottom: theme.spacing(1),
        },
    },



}));



